export const COMPANY_NAME = 'DNA Payments'
export const COMPANY_NAME_SHORT = 'DNA'

export const COMPANY_SITE = 'https://dnapayments.com'

export const COMPANY_DOMAIN = 'dnapayments.com'

export const COMPANY_LOGO_PATH = '/img/logo/dna-payments-logo-dark.svg'
export const COMPANY_LOGO_LIGHT_PATH = '/img/logo/dna-payments-logo-light.svg'

export const SUPPORT_EMAIL = 'support@dnapaymentsgroup.com'

export const TRACE_PROPAGATION_TARGETS = [
    'https//:test-portal.dnapayments.com',
    'https//:portal.dnapayments.com'
]
